import { render, staticRenderFns } from "./_SpecificField.vue?vue&type=template&id=52bc6366&"
import script from "./_SpecificField.vue?vue&type=script&lang=js&"
export * from "./_SpecificField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports